/**
 * Common constants used across the application
 */

/**
 * Default limit for fetching full lists without pagination
 * Used for dropdowns, autocompletes, and other UI components that need complete datasets
 */
export const FULL_LIST_LIMIT = 200

/**
 * Minimum search term length required to trigger search queries
 * Used for autocomplete and search suggestion components
 */
export const MIN_SEARCH_LENGTH = 2
